<template>
  <div class="w-full pb-[100px] md:pb-[160px]">
    <!-- v-if="isLoading" -->
    <!-- <van-sticky v-if="data.app_logo && data.top_text && istop">
      <div
        v-show="istop"
        class="max-w-[1400px] w-full sh tar top-0 left-0 flex items-center justify-center flex-col mx-auto bg-[#fff] z-99"
      >
        <div class="flex items-center justify-between w-full box-border p-[10px]">
          <div class="flex items-center gap-[10px]">
            <img v-if="data.app_logo" class="w-40px h-40px" :src="data.app_logo" alt="" />
            <div v-else class="w-40px h-40px"></div>
            <div class="text-[#db2639] text-[13px]">
              <div v-if="data.app_name">
                <b> {{ data.app_name }} </b>
              </div>
              <div v-if="data.app_desc">{{ data.app_desc }}</div>
            </div>
          </div>
          <div class="flex items-center gap-[10px] text-[12px]">
            <div
              v-if="data.app_url"
              class="flex items-center justify-center w-[67px] text-center h-[28px] rounded-[28px] bg-[#ff4d03] text-[#fff] cursor-pointer"
              @click="download"
            >
              下载APP
            </div>
            <van-icon size="20" name="cross" @click="istop = false" />
          </div>
        </div>
        <div
          v-if="data.top_text && data.top_text.length"
          class="grid grid-cols-5 gap-1 box-border px-[10px] pb-[10px] text-[12px] w-full"
        >
          <div
            v-for="(item, index) in data.top_text"
            :key="index"
            class="h-[25px] w-full text-[#fff] rounded-[3px] flex items-center justify-center text-center"
            :class="[index % 2 == 0 ? 'bg-[#f00]' : 'bg-[#ffae00]']"
            @click="handelUrl(item)"
          >
            {{ item.title }}
          </div>
        </div>
      </div>
    </van-sticky> -->
    <van-sticky v-if="slist && slist.length > 0">
      <div
        v-if="slist && slist.length > 0"
        class="max-w-[1400px] w-full tar flex items-center justify-center mx-auto z-99"
      >
        <van-swipe
          :show-indicators="false"
          :loop="true"
          :autoplay="3000"
          class="h-[20vw] w-full md:h-[150px]"
          vertical
        >
          <van-swipe-item
            class="h-[20vw] w-full md:h-[150px]"
            v-for="(item, index) in slist"
            :key="index"
            @click="handelUrl(item)"
          >
            <img class="w-full h-full" v-lazy="item.logo" alt="" />
          </van-swipe-item>
        </van-swipe>
      </div>
    </van-sticky>
    <TopNav
      ref="topNav"
      @handelcd="handelcd"
      @onNav="onNav"
      @onSearch="onSearch"
      :logo="data.app_logo"
      :typeClass="data.video_type_name"
      :web_name="data.web_name"
      :isHome="true"
    ></TopNav>
    <div class="md:flex md:items-start md:justify-center w-full md:gap-[20px] target">
      <!-- 导航栏 -->

      <!-- 内容 -->
      <div class="w-full min-h-[100vh] flex flex-col">
        <!-- 滚动播放 -->
        <van-notice-bar
          v-if="data.announcement"
          left-icon="volume-o"
          class="font-600 h-[30px] mt-[10px]"
          color="#555"
          background="#fff"
          scrollable
          :text="data.announcement"
        />

        <!-- 横幅 -->
        <!-- <HfView class="mt-[10px]"></HfView> -->
        <!-- 视频 -->
        <div class="w-full mt-[10px]">
          <!-- 正方形 -->

          <!-- 二维数组循环 -->
          <div class="w-full">
            <GgView :applist="data.home_app" :wzlist="data.homt_text"></GgView>

            <!-- video -->
            <HfView :list="data.home_hengfu"></HfView>
          </div>
          <div class="w-full" v-if="data.ad_list && data.ad_list.list.length > 0 && isHome">
            <div class="text-[#333] text-[18px] py-[10px] pl-[20px] w-full box-border borb">
              {{ data.ad_list.title }}
            </div>
            <VideoGg :list="data.ad_list.list"></VideoGg>
          </div>
          <div
            class="text-[#333] text-[18px] py-[10px] pl-[20px] w-full box-border borb"
            id="distance"
          >
            {{ videoTitle }}
          </div>
          <VideoList :loding="videoLoding" :list="videoList"></VideoList>
          <!-- 分页 -->
          <div
            v-if="!isHome && videoLoding"
            class="flex items-center justify-center pb-[10px] gap-[10px] text-[12px] text-[#333]"
          >
            <div
              class="cursor-pointer py-[5px] px-[15px] rounded-[5px] bobb"
              @click="handelPage(1)"
            >
              首页
            </div>
            <div
              class="cursor-pointer py-[5px] px-[15px] rounded-[5px] bobb"
              @click="handelPagetop"
            >
              上一页
            </div>
            <div class="cursor-pointer py-[5px] px-[15px] rounded-[5px] bobb">
              {{ page }}/{{ last_page }}
            </div>
            <div
              class="cursor-pointer py-[5px] px-[15px] rounded-[5px] bobb"
              @click="handelPagebottom"
            >
              下一页
            </div>
            <div class="cursor-pointer py-[5px] px-[15px] rounded-[5px] bobb" @click="handelw">
              尾页
            </div>
          </div>
        </div>
        <div
          class="w-full mt-[20px] bor box-border p-[10px] rounded-[5px] flex flex-col items-center justify-center bg-[#fff]"
        >
          <!-- https://t.me/madoudou2024 -->
          <div class="text-[14px] font-600">
            <span>商务联系：</span
            ><span class="text-[#E53333]" @click="handeltelegram(data.telegram)"
              >@{{ telegram }}</span
            >
          </div>
          <div class="text-[14px] mt-[5px]">本站永久域名：{{ data.home_domain }}</div>
          <!-- <div class="text-[14px] mt-[5px]">Copyright © 2016-2025 HTTPS://MMD2.CO 版权所有</div> -->
          <div class="text-[14px] mt-[5px]">
            免责声明：本站隶属美国，受美国政府监管，服务全球华侨华裔。
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- 上下侧边 -->
  <TopBootm ref="topBootmRef" :clist="data.home_xuanfu" :xlist="data.home_bottom"></TopBootm>
  <!-- <TcView v-if="data.pop_up && data.pop_up.length" :list="data.pop_up" @close="close"></TcView> -->
  <ZxTc
    ref="zxTxRef"
    :obj="{
      home_domain: data.home_domain,
      new_url: data.new_url,
      home_email: data.home_email,
      web_name: data.web_name,
      vpn_name: data.vpn_name,
      vpn_href: data.vpn_href
    }"
  ></ZxTc>
  <TcView v-if="data.da && data.da.length" :list="data.da" @close="close"></TcView>
  <GgTan v-if="data.xiao && data.xiao.length" ref="GgTanRef" :applist="data.xiao"></GgTan>
  <!-- <GgTan v-if="data.pop_up && data.pop_up.length" ref="GgTanRef" :applist="data.pop_up"></GgTan> -->
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount, nextTick } from 'vue'
// const { ref, onMounted, onBeforeUnmount, nextTick } = window.Vue
import { useRouter } from 'vue-router'
// const { useRouter } = window.VueRouter
import { homeData, getVideo } from '@/api/api'
import { userIndexApi } from '@/api/my'

import TopNav from '@/components/common/TopNav.vue'
import HfView from '@/components/common/HfView.vue'
import TopBootm from '@/components/common/TopBootm.vue'
import GgView from '@/components/common/GgView.vue'
import VideoGg from '@/components/common/VideoGg.vue'
import VideoList from '@/components/common/VideoList.vue'
import TcView from '@/components/common/TcView.vue'
import ZxTc from '@/components/common/ZxTc.vue'
import GgTan from '@/components/common/GgTan.vue'
import { pcScrollX, xorDecrypt } from '@/utils/common'
// import { showToast, showLoadingToast, closeToast } from 'vant'

const router = useRouter()
const isLoading = ref(false)
const videoLoding = ref(false)
const istop = ref(true)
const isMobile = ref(true)
const GgTanRef = ref(null)
const slist = ref([])
function updateWindowSize() {
  const width = window.innerWidth

  if (width <= 768) {
    // console.log('窗口宽度小于或等于 768px')
    // 可以在这里执行你想要的操作
    isMobile.value = false
  } else {
    // console.log('窗口宽度大于 768px')
    // 可以在这里执行你想要的操作
    isMobile.value = true
  }
  if (width <= 768) {
    // console.log('窗口宽度小于或等于 768px')
    // 可以在这里执行你想要的操作
    isMobile.value = false
  } else {
    // console.log('窗口宽度大于 768px')
    // 可以在这里执行你想要的操作
    isMobile.value = true
  }
}
// 初始显示窗口大小
// updateWindowSize()

// // 监听窗口大小变化
// window.addEventListener('resize', updateWindowSize)
// onBeforeUnmount(() => {
//   window.removeEventListener('resize', updateWindowSize)
// })
const zxTxRef = ref(null)
const handelcd = () => {
  zxTxRef.value.handelShow()

  // isMobile.value = !isMobile.value
}
const close = () => {
  // zxTxRef.value.handelShow()
  // nextTick(() => {
  //   if (GgTanRef.value) {
  //     GgTanRef.value.handelShow()
  //   }
  // })
}
const isHome = ref(true)
const go = ref('')
const ss = ref('')

onMounted(() => {
  const urlParams = new URLSearchParams(window.location.search)
  const pid = urlParams.get('pid')
  if (pid) {
    // console.log('PID 参数:', pid)
    istop.value = false
    // 你可以存入 Vuex、Pinia 或 localStorage
  }
  // 滚动到顶部
  window.scrollTo(0, 0)
  go.value = sessionStorage.getItem('isIndex') || ''
  ss.value = sessionStorage.getItem('vod_name') || ''
  // console.log(ss.value, 'ss')

  getHomeData()
  // getMy()
})
const videoTitle = ref('')
const type_id = ref('')
const onNav = ({ item, num }) => {
  videoTitle.value = item.type_name
  type_id.value = item.type_id
  // localStorage.removeItem('page')
  page.value = 1
  videoList.value = []
  // getVideoList(`page=${page.value}`)
  if (!item.type_id) {
    getVideoList(``, 'search')
    isHome.value = true
  } else {
    page.value = num ? num : 1
    getVideoList(`page=${page.value}&type_id=${item.type_id}`, 'search')
    isHome.value = false
  }
}
const page = ref(1)
const videoList = ref([])
const last_page = ref(0)
const getVideoList = async (param, type) => {
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: 'smooth'
  })
  videoLoding.value = false
  videoList.value = []
  const res = await getVideo(param)
  let decodedString = atob(res.key)
  // const data = JSON.parse(xorDecrypt(res.data, decodedString))
  const datas = JSON.parse(xorDecrypt(res.data, decodedString))
  // console.log(res)
  if (datas.title) {
    videoList.value = datas.list
    videoTitle.value = datas.title
    videoLoding.value = true
    return
  }
  last_page.value = datas.last_page
  if (type == 'search') {
    videoList.value = datas.data
  } else {
    videoList.value = datas
  }
  videoLoding.value = true
}

const download = () => {
  if (!data.value.app_url) return
  window.open(data.value.app_url, '_blank')
}

const topBootmRef = ref(null)
const topNav = ref(null)
const data = ref({})
const telegram = ref('')
const getHomeData = async () => {
  try {
    const res = await homeData()
    // console.log(res)

    if (res == 304) {
      const bas = JSON.parse(localStorage.getItem('data'))
      let decodedString = atob(bas.key)
      // const data = JSON.parse(xorDecrypt(res.data, decodedString))
      const datas = JSON.parse(xorDecrypt(bas.data, decodedString))
      // console.log(datas, 'datas')

      if (datas.video_type_name.length) {
        if (datas.video_type_name[0].type_name != '首页') {
          datas.video_type_name.unshift({ type_id: 0, type_name: '首页' })
        }
      }
      data.value = datas
      data.value.xiao = data.value.pop_up.filter((item) => item.type === 1)
      data.value.da = data.value.pop_up.filter((item) => item.type === 2)
    } else {
      localStorage.setItem('data', JSON.stringify(res))
      let decodedString = atob(res.key)
      // const data = JSON.parse(xorDecrypt(res.data, decodedString))
      const datas = JSON.parse(xorDecrypt(res.data, decodedString))
      datas.video_type_name.unshift({ type_id: 0, type_name: '首页' })
      data.value = datas
      data.value.xiao = data.value.pop_up.filter((item) => item.type === 1)
      data.value.da = data.value.pop_up.filter((item) => item.type === 2)
    }
    // console.log(data.value, 'datas66666')
    slist.value = data.value.home_top
    // data.value.pop_up = ''

    if (data.value.xiao && data.value.xiao.length) {
      nextTick(() => {
        if (GgTanRef.value) {
          GgTanRef.value.handelShow()
        }
      })
    }

    // if (!data.value.pop_up || data.value.pop_up.length == 0) {
    //   console.log(123)

    //   close()
    // }
    document.title = data.value.web_name
    // 使用正则表达式提取 `https://t.me/` 后面的部分
    if (data.value.telegram) {
      let match = data.value.telegram.match(/https:\/\/t\.me\/(.*)/)
      if (match) {
        telegram.value = match[1] // match[1] 是正则表达式中第一个捕获组的内容
      }
    }
    page.value = 1
    // console.log(res, '2222')
    videoTitle.value = data.value.video_type_name[0].type_name
    type_id.value = data.value.video_type_name[0].type_id
    // getVideoList(`page=${page.value}`, 'list')
    nextTick(() => {
      isLoading.value = true
      setTimeout(() => {
        topBootmRef.value.scroll()
        pcScrollX()
      }, 50)
    })
    if (ss.value) {
      // 这里是搜索
      onSearch(ss.value)
      sessionStorage.removeItem('vod_name')
      return
    }
    if (go.value) {
      nextTick(() => {
        setTimeout(() => {
          page.value = +localStorage.getItem('page') || 1
          topNav.value.homeClassNav(page.value)
        }, 200)
        // sessionStorage.removeItem('go')
      })
    } else {
      getVideoList(``, 'search')
    }
    // closeToast()
  } catch (error) {
    localStorage.removeItem('data')
    localStorage.removeItem('lastModified')
    // 刷新页面
    location.reload()
  }
}

// 搜索
const onSearch = (name) => {
  page.value = 1
  getVideoList(`page=${page.value}&vod_name=${name}`, 'search')
}

// 返回首页第一页
const handelPage = () => {
  if (page.value == 1) return
  page.value = 1
  getVideoList(`page=${page.value}&type_id=${type_id.value}`, 'search')
}

const handelPagetop = () => {
  if (page.value > 1) {
    page.value--
    localStorage.setItem('page', page.value)
    getVideoList(`page=${page.value}&type_id=${type_id.value}`, 'search')
  }
}
const handelPagebottom = () => {
  if (page.value == last_page.value) return
  page.value++
  localStorage.setItem('page', page.value)
  getVideoList(`page=${page.value}&type_id=${type_id.value}`, 'search')
}

const handelw = () => {
  if (page.value == last_page.value) return
  page.value = last_page.value
  localStorage.setItem('page', page.value)
  getVideoList(`page=${page.value}&type_id=${type_id.value}`, 'search')
}

const handeltelegram = (item) => {
  if (item) {
    window.open(item, '_blank')
  }
}
const handelUrl = (item) => {
  window.open(item.href, '_blank')
}
</script>

<style scoped>
.borb {
  border-bottom: 1px solid #eee;
}
.bobb {
  border: 1px solid #eee;
}
.sh {
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
}
</style>
